import {Typography} from 'antd';
import {ReactElement, useState} from 'react';

import {Locale} from '../../../../../../../../provider/locale/localization';
import {ReviewHistoryDataType} from '../../../../../../../../service/reviews/reviews-history';

type PropsType = {
    value: ReviewHistoryDataType['oldValue'];
};

function toHistoryText(value: ReviewHistoryDataType['oldValue']): string {
    return typeof value === 'string' ? value : '';
}

export function HistoryExpandableText(props: PropsType): ReactElement | null {
    const {value} = props;

    const [expanded, setExpanded] = useState<boolean>(false);

    const text = toHistoryText(value);

    if (!text) {
        return null;
    }

    return (
        <Typography.Paragraph
            ellipsis={{
                rows: 3,
                expandable: 'collapsible',
                expanded,
                onExpand: (_data, info) => setExpanded(info.expanded),
                symbol: (
                    <Locale
                        stringKey={expanded ? 'REVIEWS__REVIEW_ABUSE__HIDE_TEXT' : 'REVIEWS__REVIEW_ABUSE__SHOW_TEXT'}
                    />
                ),
            }}
            type="secondary"
        >
            {text}
        </Typography.Paragraph>
    );
}
